<template>
  <Layout>
    <Sider class="siderclass" collapsible v-model="isCollapsed" :collapsed-width="30" :hide-trigger="true"  ref="assistantSider" @on-collapse="changestate" :style="{background:treeDisp?'#fff':'#515a6e'}">
      <Button type="text" @click="toggle" icon="ios-menu" :style="{width:'100%',borderRadius:'0px',boxShadow:'none',color:'white',background:'#2db7f5',display:leftTreeToggleMenuBtn?'block':'none'}" size="small"></Button>
      <Menu :theme="theme3" :active-name="activeName" width="auto" height="80vh" @on-select="showmap" :style="{width:'100%',display:treeDisp?'block':'none'}">
        <MenuGroup title="我的秘书">
          <MenuItem name="1">
          <Icon type="ios-folder" />
          <!-- 云端变动提醒 -->
          文件提醒
          </MenuItem>
          <MenuItem name="2">
          <Icon type="ios-create" />
          <!-- 历史查询记录 -->
          查询记录
          </MenuItem>
        </MenuGroup>
      </Menu>
    </Sider>
    <Layout>
    <Content>
 <!--      <MyRoadMap ref="myroad" style="padding-left: 10px;"></MyRoadMap> -->
      <Card class="contentclass">
        <div style="height: auto;">
          <router-view v-if="isRouterAlive"></router-view>
        </div>
      </Card>
    </Content>
  </Layout>
  </Layout>
</template>
<script>
import Vue from 'vue'
import RoadMap from './../road_map.vue'
export default {
  name: 'MyAssistant',
  data() {
    return {
      theme3: 'primary',
      isRouterAlive: false,
      pageType: "",
      activeName: "1",
       isCollapsed: false,
      leftTreeToggleMenuBtn: true,
      treeDisp: true,
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    showmap(t) {
      //console.log(maps);
      let maps = [];
      let mycloud = [{
          key: "我的秘书",
          value: "我的秘书",
          type: "assistant",
        },
        {
          key: "云端变动提醒",
          value: "云端变动提醒",
          type: "cloudmsg",
        },
      ];
      let mydoc = [{
          key: "我的秘书",
          value: "我的秘书",
          type: "assistant",
        },
        {
          key: "历史查询记录",
          value: "历史查询记录",
          type: "cloudhistory",
        },
      ];
      if (t === "1") {
        // this.$refs.myroad.listen(mycloud);
        maps = mycloud
      } else if (t === "2") {
        // this.$refs.myroad.listen(mydoc);
        maps = mydoc
      }

      this.$router.push({
        name: 'myassistant',
        query: {
          q_type: maps[maps.length - 1].type,
        }
      })
      this.reload()
    },
    reload() {
      this.isRouterAlive = false
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    switch () {
      if (this.pageType == "cloudmsg") {
        this.showmap("1")
        this.activeName = "1"
      } else if (this.pageType == "cloudhistory") {
        this.showmap("2")
        this.activeName = "2"
      } else {
        this.showmap("1")
        this.activeName = "1"
      }
    },
    toggle() {
      this.$refs.assistantSider.toggleCollapse()
    },
    changestate(state) {
      this.treeDisp = !state;
    },
  },
  components: {
    'MyRoadMap': RoadMap,
  },
  mounted: function() {
    this.pageType = this.$route.query.q_type
    this.switch()
    //console.log(this.classid)
  },
  watch: {
    '$route'(to, from) {
      this.pageType = this.$route.query.q_type
      this.switch()
    }
  }
}

</script>
<style lang="scss" scoped>
$main-height:88.7vh;
.siderclass {
  height:$main-height;
  left: 0;
  overflow: auto;
  background: #fff;
  z-index: 1;
  // {position: 'fixed', height: '100vh', left: 0, overflow: 'auto'}
}

.layoutclass{
  height:$main-height;
}

.contentclass {
  height:$main-height;
  
}

.ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
  color: white;
  background: #2d8cf0;
  z-index: 2;
}

.ivu-menu {
  position: static;
}

</style>
